import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-692a462e")

_pushScopeId("data-v-692a462e")
const _hoisted_1 = { class: "calendar-frame" }
const _hoisted_2 = { class: "calendar-header" }
const _hoisted_3 = { class: "calendar-content" }
const _hoisted_4 = { class: "calendar-week-name" }
const _hoisted_5 = { class: "calender-number" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "calender-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMonth(-1)))
      }, [
        _createVNode(_component_fa_icon, { icon: "angle-left" })
      ]),
      _createVNode("div", null, _toDisplayString(_ctx.year) + "年 " + _toDisplayString(_ctx.month + 1) + "月", 1),
      _createVNode("div", {
        class: "calender-button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMonth(1)))
      }, [
        _createVNode(_component_fa_icon, { icon: "angle-right" })
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.calendarHeader, (name, index) => {
          return (_openBlock(), _createBlock("div", {
            key: 'week-name'+index,
            class: [
            'calendar-week-name-item',
            index==='日' ? 'calendar-week-name-item-sunday' : '',
            index==='土' ? 'calendar-week-name-item-saturday' : ''
          ]
          }, _toDisplayString(name), 3))
        }), 128))
      ]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.calendar, (week, weekIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "calendar-number-row",
            key: 'week'+weekIndex
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(week, (day, dayIndex) => {
              return (_openBlock(), _createBlock(_Fragment, null, [
                day
                  ? (_openBlock(), _createBlock("div", {
                      key: `day${weekIndex}-${dayIndex}-${day}`,
                      class: _ctx.dayClass(day),
                      onClick: ($event: any) => (_ctx.onSelectDate(day))
                    }, _toDisplayString(day), 11, ["onClick"]))
                  : (_openBlock(), _createBlock("div", {
                      key: 'day'+weekIndex+'-'+dayIndex,
                      class: "calendar-day-frame-invalid"
                    }))
              ], 64))
            }), 256))
          ]))
        }), 128))
      ])
    ])
  ]))
})